interface ProgrammeTypeFilterOption {
	id: string;
	label: string;
	filterValue?: 'club' | 'live';
}

export interface ProgrammeTypeFilter {
	id: 'type-filter';
	label: string;
	filterParameter: 'type';
	options: ProgrammeTypeFilterOption[];
}

export const programmeTypeFilter: ProgrammeTypeFilter = {
	id: 'type-filter',
	label: 'Show',
	filterParameter: 'type',
	options: [
		{
			id: 'type-filter-all',
			label: 'All',
			filterValue: undefined,
		},
		{
			id: 'type-filter-club',
			label: 'Club',
			filterValue: 'club',
		},
		{
			id: 'type-filter-live',
			label: 'Live',
			filterValue: 'live',
		},
	],
};
